<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  firstName: { type: String, default: '' },
  processData: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const location = computed(() =>
  [props.processData.bairro, props.processData.cidade]
    .filter(Boolean)
    .join(' - ')
);
const address = computed(() => {
  const street = [props.processData.logradouro, props.processData.numero]
    .filter(Boolean)
    .join(', ');
  const details = [props.processData.unidade, props.processData.complemento]
    .filter(Boolean)
    .join(' / ');

  return [street, details].filter(Boolean).join(' / ');
});
const initials = value =>
  String(value || '')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0])
    .join('')
    .toUpperCase();
</script>

<template>
  <section
    class="flex flex-col justify-between gap-6 rounded-lais border border-lais-border-soft bg-white p-5 shadow-lais-card lg:flex-row lg:items-end"
  >
    <div class="min-w-0">
      <h2 class="font-redHatDisplay text-2xl font-bold text-lais-text">
        {{
          t('REAL_ESTATE_COMMISSION_PLAN.HEADER.GREETING', {
            name: firstName,
          })
        }}
      </h2>
      <div class="mt-4 flex items-start gap-2 text-sm text-lais-text-muted">
        <span
          class="i-lucide-map-pin mt-0.5 size-4 shrink-0"
          aria-hidden="true"
        />
        <div>
          <p v-if="location" data-test="commission-plan-location">
            {{ location }}
          </p>
          <p data-test="commission-plan-address">
            {{
              address ||
              t('REAL_ESTATE_COMMISSION_PLAN.COMMON.ADDRESS_UNAVAILABLE')
            }}
          </p>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap gap-6 lg:justify-end">
      <article
        v-if="processData.pos_venda_id"
        data-test="commission-plan-post-sale"
        class="flex items-center gap-3"
      >
        <span
          class="grid size-12 place-items-center rounded-full bg-lais-primary-50 text-sm font-bold text-lais-primary"
        >
          {{ initials(processData.pos_venda_name) }}
        </span>
        <div>
          <p class="text-xs font-bold uppercase text-lais-text-muted">
            {{ t('REAL_ESTATE_COMMISSION_PLAN.HEADER.POST_SALE') }}
          </p>
          <p class="font-semibold text-lais-text">
            {{ processData.pos_venda_name }}
          </p>
        </div>
      </article>
      <article
        v-if="processData.gerente_id"
        data-test="commission-plan-manager"
        class="flex items-center gap-3"
      >
        <span
          class="grid size-12 place-items-center rounded-full bg-lais-primary-50 text-sm font-bold text-lais-primary"
        >
          {{ initials(processData.gerente_name) }}
        </span>
        <div>
          <p class="text-xs font-bold text-lais-text-muted">
            {{ t('REAL_ESTATE_COMMISSION_PLAN.HEADER.MANAGER') }}
          </p>
          <p class="font-semibold text-lais-text">
            {{ processData.gerente_name }}
          </p>
          <p class="text-xs text-lais-text-muted">
            {{ processData.loja_name }}
          </p>
        </div>
      </article>
    </div>
  </section>
</template>
